import { createAsyncThunk } from '@reduxjs/toolkit';

import type {
  ECategories,
  ESort,
} from 'shared/repositories/commercial-buildings/entities/entities/V1GetBuildingCategoryOffersRequest';
import { getBuildingCategoryOffers } from 'shared/services/getBuildingCategoryOffers';
import type { IApplicationContext } from 'shared/types/applicationContext';
import type { IBuildingCard } from 'shared/types/buildingCard';
import type { IBuildingOffersState, ICategoryOffers } from 'shared/types/buildingOffers';
import { getOffersApiSort, getOffersCategory } from 'shared/utils/buildingOffers';

/** Часть состояния, которую читает thunk: полный тип стора зависел бы от этого же слайса */
interface IThunkState {
  buildingCard: IBuildingCard;
  buildingOffers: IBuildingOffersState;
}

/** Объявления текущей выборки фильтров и сортировки */
export const fetchBuildingOffers = createAsyncThunk<
  ICategoryOffers,
  void,
  { state: IThunkState; extra: IApplicationContext }
>('buildingOffers/fetch', (_, { getState, extra: { httpApi, logger } }) => {
  const { buildingCard, buildingOffers } = getState();
  const { filters, sort, subdomain } = buildingOffers;

  if (!filters.propertyType) {
    return { offers: [], offersCount: 0 };
  }

  return getBuildingCategoryOffers({
    httpApi,
    logger,
    parameters: {
      buildingId: buildingCard.id,
      categories: [getOffersCategory(filters.dealType, filters.propertyType) as ECategories],
      fromRepresentative: filters.isFromRepresentative,
      // Значения совпадают с enum клиента: строковые union и enum TypeScript не приводятся друг к другу
      sort: getOffersApiSort(filters.dealType, sort) as ESort | undefined,
      subdomain,
    },
  });
});
